/**
 * Rubina Irfan — Wishlist Page JS
 * Reads saved items from localStorage('ri-wishlist'), fetches each
 * product via /products/{handle}.js, and renders cards reusing the
 * existing .ri-product-card markup/styles. Items are saved by the
 * heart-icon button on the product page (see ri-product.js).
 */
(function () {
  'use strict';

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }

  document.addEventListener('DOMContentLoaded', function () {
    var grid     = qs('#ri-wishlist-grid');
    var empty    = qs('#ri-wishlist-empty');
    var loading  = qs('#ri-wishlist-loading');
    var countEl  = qs('#ri-wishlist-count');
    if (!grid) return;

    var items = readWishlist();

    if (!items.length) {
      showEmpty();
      return;
    }

    Promise.all(items.map(fetchProduct)).then(function (results) {
      var found = results.filter(Boolean);

      /* Drop any saved items whose product no longer exists (deleted/
         unpublished) so the badge count and storage stay accurate. */
      if (found.length !== items.length) {
        writeWishlist(found.map(function (p) { return { id: p.__wishId, handle: p.handle }; }));
      }

      if (!found.length) {
        showEmpty();
        return;
      }

      renderGrid(found);
      setLoading(false);
      grid.hidden = false;
      updateCount(found.length);
    });

    /* ── Data ── */
    function readWishlist() {
      try {
        var raw = JSON.parse(localStorage.getItem('ri-wishlist') || '[]');
        return raw.filter(function (item) { return item && item.id && item.handle; });
      } catch (e) {
        return [];
      }
    }

    function writeWishlist(items) {
      try { localStorage.setItem('ri-wishlist', JSON.stringify(items)); } catch (e) {}
    }

    function fetchProduct(item) {
      return fetch('/products/' + item.handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (product) {
          if (!product) return null;
          product.__wishId = item.id;
          return product;
        })
        .catch(function () { return null; });
    }

    /* ── Render ── */
    function renderGrid(products) {
      grid.innerHTML = products.map(cardHtml).join('');
      products.forEach(function (product) {
        var card = grid.querySelector('[data-wish-id="' + product.__wishId + '"]');
        var btn  = card && card.querySelector('[data-remove]');
        if (btn) btn.addEventListener('click', function () { removeItem(product.__wishId, card); });
      });
    }

    function cardHtml(product) {
      var img   = product.featured_image
        ? product.featured_image + (product.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=800'
        : '';
      var title = escapeHtml(product.title);
      var price = priceHtml(product);

      return (
        '<article class="ri-product-card ri-product-card--full ri-wishlist-card" data-wish-id="' + product.__wishId + '">' +
          '<button type="button" class="ri-wishlist-card__remove" data-remove aria-label="Remove ' + title + ' from wishlist">' +
            '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">' +
              '<path d="M18 6 6 18M6 6l12 12"/>' +
            '</svg>' +
          '</button>' +
          '<div class="ri-product-card__media">' +
            '<a href="' + product.url + '" class="ri-product-card__img-link" tabindex="-1" aria-hidden="true">' +
              (img ? '<img src="' + img + '" loading="lazy" class="ri-product-card__img ri-product-card__img--primary" alt="' + title + '" width="400" height="500">' : '') +
            '</a>' +
          '</div>' +
          '<div class="ri-product-card__body">' +
            '<h3 class="ri-product-card__title"><a href="' + product.url + '">' + title + '</a></h3>' +
            '<div class="ri-product-card__price">' + price + '</div>' +
          '</div>' +
        '</article>'
      );
    }

    function priceHtml(product) {
      var price   = product.price;
      var compare = product.compare_at_price;
      if (compare && compare > price) {
        return '<s class="ri-product-card__price--compare">' + formatMoney(compare) + '</s>' +
               '<span class="ri-product-card__price--sale">' + formatMoney(price) + '</span>';
      }
      return '<span>' + formatMoney(price) + '</span>';
    }

    /* ── Remove ── */
    function removeItem(id, card) {
      var remaining = readWishlist().filter(function (item) { return item.id !== id; });
      writeWishlist(remaining);

      if (card) {
        card.classList.add('is-removing');
        card.addEventListener('transitionend', function () { card.remove(); }, { once: true });
      }

      var newCount = grid.querySelectorAll('.ri-wishlist-card').length - 1;
      updateCount(Math.max(newCount, 0));
      if (newCount <= 0) {
        setTimeout(showEmpty, 260);
      }
    }

    /* ── UI helpers ── */
    function showEmpty() {
      setLoading(false);
      if (grid) grid.hidden = true;
      if (empty) empty.hidden = false;
      updateCount(0);
    }

    function setLoading(on) {
      if (loading) loading.hidden = !on;
    }

    function updateCount(n) {
      if (countEl) countEl.textContent = n ? '(' + n + ')' : '';
    }

    function escapeHtml(str) {
      return String(str || '').replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    /* Goes into an innerHTML string, so keep whatever markup money_format
       carries. RIMoney adds the thousands separators the old local copy
       dropped — PKR prices were rendering as "Rs1449900.00". */
    function formatMoney(cents) {
      return window.RIMoney.format(cents);
    }
  });
})();
